module.exports = __webpack_public_path__ + "static/img/entrance2.2befa0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/fcsw/entrance2.jpg
// module id = UI4F
// module chunks = 1